"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var position_enum_1 = __importDefault(require("../../shared/enums/position.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var icon_1 = __importDefault(require("../icon"));
require("./enhanced-icon.scss");
function EnhancedIcon(props) {
    var _a;
    var textClass = "";
    if (props.title) {
        if (props.textPosition === position_enum_1.default.LEFT) {
            textClass = "left";
        }
        else if (props.textPosition === position_enum_1.default.RIGHT) {
            textClass = "right";
        }
    }
    var icon = (react_1.default.createElement("div", { className: (0, classMap_1.default)("enhanced-icon-icon", props.enhancedClassName) },
        react_1.default.createElement(icon_1.default, __assign({}, props, { title: props.title, alt: (_a = props.alt) !== null && _a !== void 0 ? _a : undefined }))));
    var text = (react_1.default.createElement("div", { className: (0, classMap_1.default)("enhanced-icon-text", props.textClassName, textClass) },
        react_1.default.createElement("span", null, props.title)));
    var position = props.textPosition ? props.textPosition : position_enum_1.default.LEFT;
    var before = position === position_enum_1.default.TOP || position === position_enum_1.default.LEFT;
    var enhancedIcon = before ? (react_1.default.createElement(react_1.default.Fragment, null,
        text,
        icon)) : (react_1.default.createElement(react_1.default.Fragment, null,
        icon,
        text));
    var vertical = position === position_enum_1.default.TOP || position === position_enum_1.default.BOTTOM;
    var classes = vertical ? "flex-column" : "align-items-center";
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-enhanced-icon d-flex", props.enhancedIconClassName, classes) }, enhancedIcon));
}
exports.default = EnhancedIcon;
